<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">

            <x-form-group label="Label"
                :error="getError('label')"
                :is-required="true">
                <input type="text"
                    class="form-control"
                    v-model="fields.label"
                    required />
            </x-form-group>

            <x-form-group label="Deskripsi"
                :error="getError('description')"
                :is-required="false">
                <textarea class="form-control"
                    v-model="fields.description" />
            </x-form-group>

            <x-form-group label="Akses"
                :error="getError('permissions')"
                :is-required="false">
                <x-filter-box v-for="(permission, index) in availablePermissions" 
                    :key="`${index}`"
                    :title="permission.label"
                    :readonly="true"
                    :help-text="permission.description || null"
                    :id="`${index}`"
                    :open="true">
                    <template #subtitle v-if="!disabled">
                        <a v-if="permissionHasNoAccess(permission)" 
                            href="javascript:;" 
                            title="Klik untuk beri akses penuh"
                            @click="givePermissionFullAccess(permission)">
                            <i class="fa fa-square-o" /> Beri akses penuh
                        </a>
                        <a v-else 
                            href="javascript:;" 
                            title="Klik untuk hapus semua akses"
                            @click="restrictAllPermissionAccess(permission)">
                            <i :class="{
                                'fa': true, 
                                'fa-check-square-o': permissionHasFullAccess(permission),
                                'fa-square': permissionHasPartialAccess(permission),
                            }" /> Hapus semua akses
                        </a>
                    </template>
                    <x-checkbox-wrapper v-for="(access, subIndex) in permission.items"     
                        :key="`${index}-${subIndex}`"
                        :label="access.label">
                        <input type="checkbox" 
                            v-model="fields.permissions"
                            :value="access.key"
                            @change="handleToggle(access)" />
                        <template #description v-if="access.description">
                            <span class="help-block">
                                {{ access.description }}
                            </span>
                        </template>
                    </x-checkbox-wrapper>
                </x-filter-box>
            </x-form-group>

        </fieldset>
    </form>
</template>

<script>
import XCheckboxWrapper from '../../components/XCheckboxWrapper.vue'
import XFilterBox from '../../components/XFilterBox.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import { handleGeneralXhrError } from '../../helpers'
import FormErrorMixin from '../../mixins/FormErrorMixin'

export default {
    components: {
        XFormGroup,
        XFilterBox,
        XCheckboxWrapper,
    },
    created() {
        this.fetchPermissions()
        this.fields = {
            ...this.fields,
            ...this.initialFields,
        }
        if (this.fields.permissions === null) {
            this.fields.permissions = []
        }
    },
    data() {
        return {
            availablePermissions: [],
            fields: {
                description: null,
                label: null,
                permissions: [],
            },
        }
    },
    methods: {
        fetchPermissions() {
            this.isLoading = true
            const request = axios.get('/api/group-roles/permissions')
                .then(response => {
                    this.availablePermissions = response.data.data
                })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        givePermissionFullAccess(permission) {
            permission.items.filter(access => {
                return !Boolean(access.restricted)
            }).forEach(access => {
                if (!this.fields.permissions.includes(access.key)) {
                    this.fields.permissions.push(access.key)
                }
            })
        },
        handleSubmit() {
            this.$emit('submit', this.fields)
        },
        permissionHasFullAccess(permission) {
            let hasFullAccess = true
            for (let key in permission.items) {
                const access = permission.items[key]
                if (Boolean(access.restricted)) {
                    continue
                }
                if (!this.fields.permissions.includes(access.key)) {
                    hasFullAccess = false
                }
            }
            return hasFullAccess
        },
        permissionHasNoAccess(permission) {
            let hasNoAccess = true
            for (let key in permission.items) {
                const access = permission.items[key]
                if (this.fields.permissions.includes(access.key)) {
                    hasNoAccess = false
                }
            }
            return hasNoAccess
        },
        permissionHasPartialAccess(permission) {
            if (this.permissionHasFullAccess(permission)) {
                return false
            }
            for (let key in permission.items) {
                const access = permission.items[key]
                if (this.fields.permissions.includes(access.key)) {
                    return true
                }
            }
        },
        restrictAllPermissionAccess(permission) {
            let forbidden = []
            permission.items.forEach(access => {
                forbidden.push(access.key)
            })
            this.fields.permissions = this.fields.permissions.filter(choice => {
                return !forbidden.includes(choice)
            })
        },
    },
    mixins: [
        FormErrorMixin,
    ],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialFields: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
}
</script>